var map = {
	"./BackToTopButton/viewer/BackToTopButton.mapper.ts": 23,
	"./BackToTopButton/viewer/BackToTopButton.previewMapper.ts": 32,
	"./Captcha/viewer/Captcha.mapper.ts": 27,
	"./Captcha/viewer/Captcha.previewMapper.ts": 33,
	"./CustomElementComponent/viewer/CustomElementComponent.mapper.ts": 24,
	"./CustomElementComponent/viewer/CustomElementComponent.previewMapper.ts": 34,
	"./FacebookShare/viewer/FacebookShare.mapper.ts": 25,
	"./FacebookShare/viewer/FacebookShare.previewMapper.ts": 35,
	"./GoogleMap/viewer/GoogleMap.mapper.ts": 9,
	"./GoogleMap/viewer/GoogleMap.previewMapper.ts": 36,
	"./HtmlComponent/viewer/HtmlComponent.mapper.ts": 10,
	"./HtmlComponent/viewer/HtmlComponent.previewMapper.ts": 37,
	"./ImageButton/viewer/ImageButton.mapper.ts": 11,
	"./ImageButton/viewer/ImageButton.previewMapper.ts": 38,
	"./ItunesButton/viewer/ItunesButton.mapper.ts": 12,
	"./ItunesButton/viewer/ItunesButton.previewMapper.ts": 39,
	"./MenuToggle/viewer/MenuToggle.mapper.ts": 26,
	"./MenuToggle/viewer/MenuToggle.previewMapper.ts": 40,
	"./PayPalButton/viewer/PayPalButton.mapper.ts": 20,
	"./PayPalButton/viewer/PayPalButton.previewMapper.ts": 41,
	"./PinterestPinIt/viewer/PinterestPinIt.mapper.ts": 28,
	"./PinterestPinIt/viewer/PinterestPinIt.previewMapper.ts": 42,
	"./ProgressBar/viewer/ProgressBar.mapper.ts": 21,
	"./ProgressBar/viewer/ProgressBar.previewMapper.ts": 43,
	"./SelectionTagsList/viewer/SelectionTagsList.mapper.ts": 7,
	"./SelectionTagsList/viewer/SelectionTagsList.previewMapper.ts": 44,
	"./Slider/viewer/Slider.mapper.ts": 22,
	"./Slider/viewer/Slider.previewMapper.ts": 45,
	"./SoundCloudWidget/viewer/SoundCloudWidget.mapper.ts": 8,
	"./SoundCloudWidget/viewer/SoundCloudWidget.previewMapper.ts": 46,
	"./StylableHorizontalMenu/viewer/StylableHorizontalMenu.mapper.ts": 57,
	"./ToggleSwitch/viewer/ToggleSwitch.mapper.ts": 47,
	"./ToggleSwitch/viewer/ToggleSwitch.previewMapper.ts": 48,
	"./VKShareButton/viewer/VKShareButton.mapper.ts": 13,
	"./VKShareButton/viewer/VKShareButton.previewMapper.ts": 49,
	"./VideoPlayer/viewer/VideoPlayer.mapper.ts": 14,
	"./VideoPlayer/viewer/VideoPlayer.previewMapper.ts": 50,
	"./WFacebookComment/viewer/WFacebookComment.mapper.ts": 15,
	"./WFacebookComment/viewer/WFacebookComment.previewMapper.ts": 51,
	"./WFacebookLike/viewer/WFacebookLike.mapper.ts": 29,
	"./WFacebookLike/viewer/WFacebookLike.previewMapper.ts": 52,
	"./WRichText/viewer/WRichText.previewMapper.ts": 53,
	"./WTwitterFollow/viewer/WTwitterFollow.mapper.ts": 16,
	"./WTwitterFollow/viewer/WTwitterFollow.previewMapper.ts": 54,
	"./WTwitterTweet/viewer/WTwitterTweet.mapper.ts": 18,
	"./WTwitterTweet/viewer/WTwitterTweet.previewMapper.ts": 55,
	"./YouTubeSubscribeButton/viewer/YouTubeSubscribeButton.mapper.ts": 19,
	"./YouTubeSubscribeButton/viewer/YouTubeSubscribeButton.previewMapper.ts": 56
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31;